<template>
  <div>
      <p class="mt-5 mb-5">Name :</p>
      <p class="text-muted mt-5 mb-0">
        <ul>
            <li>{{ dataemer[0].name_en }}</li>
            <li>{{ dataemer[0].name_th }}</li>
        </ul>
      </p>
      <p class="mt-5 mb-5">Tel : {{ dataemer[0].tel }}</p>
      <p class="mt-5 mb-5">E-mail : <strong class="f-12"><a :href="`mailto:${dataemer[0].mail}`">{{ dataemer[0].mail }}</a></strong></p>
      <p class="mt-5 mb-5">Address : {{ dataemer[0].address }}</p>
      <p class="mt-5 mb-5">
          Sub District : {{ dataemer[0].SubDistrict }}
    </p>
    <p class="mt-5 mb-5">
          Province : {{ dataemer[0].Province }}
    </p>
    <p class="mt-5 mb-5">
          Country : {{ dataemer[0].Country }}
    </p>
    <p class="mt-5 mb-5">
          Postal Code : {{ dataemer[0].Code }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    dataemer: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-12 {
  font-size: 12px;
  font-weight: 300;
}
</style>